// ─────────────────────────────────────────
// buttons.ts — CTA and scroll button wiring
// Tauvior Landing Page
// ─────────────────────────────────────────

import { scrollToSection } from './utils';

/**
 * Map of button IDs → section IDs they should scroll to.
 * Add new entries here as more CTA buttons are added to the HTML.
 */
const BUTTON_SCROLL_MAP: Record<string, string> = {
  'cta-schedule-btn': 'contato',
  'cta-portfolio-btn': 'contato',
};

/**
 * Wires all buttons that have a `data-scroll-to` attribute.
 * <button data-scroll-to="servicos">Ver soluções</button>
 */
function wireDataScrollButtons(): void {
  const buttons = document.querySelectorAll<HTMLButtonElement>('[data-scroll-to]');

  buttons.forEach((btn) => {
    const targetId = btn.dataset.scrollTo;
    if (!targetId) return;

    btn.addEventListener('click', () => {
      scrollToSection({ targetId });
    });
  });
}

/**
 * Wires buttons by their explicit IDs from BUTTON_SCROLL_MAP.
 */
function wireIdButtons(): void {
  Object.entries(BUTTON_SCROLL_MAP).forEach(([btnId, sectionId]) => {
    const btn = document.getElementById(btnId);
    btn?.addEventListener('click', () => {
      scrollToSection({ targetId: sectionId });
    });
  });
}

/**
 * Adds a subtle press effect to all .btn-primary and .btn-secondary elements.
 */
function wireButtonPressEffect(): void {
  const buttons = document.querySelectorAll<HTMLButtonElement>('.btn-primary, .btn-secondary');

  buttons.forEach((btn) => {
    btn.addEventListener('mousedown', () => {
      btn.style.transform = 'scale(0.97)';
    });

    btn.addEventListener('mouseup', () => {
      btn.style.transform = '';
    });

    btn.addEventListener('mouseleave', () => {
      btn.style.transform = '';
    });
  });
}

/**
 * Initialises all button interactions.
 */
export function initButtons(): void {
  wireDataScrollButtons();
  wireIdButtons();
  wireButtonPressEffect();
}
